import React from 'react';
import ModalFilterPdqMerchantsComponent from './modal-filter-pdq-merchants.component';

function ModalFilterPdqMerchants(props) {
    return <ModalFilterPdqMerchantsComponent {...props} />;
}

export default ModalFilterPdqMerchants;
